import React, { Component } from 'react';
import { Button, Table, Jumbotron, Container, Row, Col, OverlayTrigger, Tooltip, Form, Modal } from 'react-bootstrap';
import { MdDeleteForever } from 'react-icons/md';
import Auth from '../../middleware/auth';
import funciones from '../../middleware/funciones';
// ;
import config from '../../config';
import { saveAs } from 'file-saver';
import Spinner from '../subcomponent/spinner';
import Modalobs from '../subcomponent/modalObservacion';
import CustomModal from '../subcomponent/CustomModal';
import { toast } from '../widgets/alerts/Toast';

class Gestiones extends Component {
  constructor(props) {
    super(props);
    const currentCompany = sessionStorage.getItem('company');
    const currentUserType = sessionStorage.getItem('tipo');
    const state = Auth.isAuthenticated();
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;

    this.state = {
      documentos: [],
      docPendientes: [],
      docProceso: [],
      docToSend: [],
      resoluciones: [],
      empresa: currentCompany,
      tipo: currentUserType,
      isLogin: state,
      tipo_documento: "",
      numero_inicial: "",
      numero_final: "",
      searchTipo: "",
      searchTipoDian: "",
      searchNumero: "",
      searchCliente: "",
      searchTransaccion: "",
      fecha_inicial: todayFormat,
      fecha_final: todayFormat,
      searchEstado: "",
      loading: false,
      visObsPDF: false,
      listAllPDF: 0,
      historial: false,
      provider: "",
      showConfirmModal: false,
      showSuccessModal: false,
      currentDeleteDoc: null
    };
  }

  componentDidMount() {
    const { empresa } = this.state
    const { tipo } = this.state
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/resoluciones/', datasend)
      .then(res => res.json())
      .then((data) => {
        this.setState({ resoluciones: data });

      })
      .catch((error) => console.error(error))
    fetch(config.servBackEnd + '/companies/parameters/', datasend)
      .then(res => res.json())
      .then((data) => {
        if (data.ok) {
          const datos = data.data[0];
          this.setState({ provider: datos.PROVEEDOR_FE });
          // this.reconteo();
        }
      })
      .catch((error) => console.error(error));
  };

  updateInfo = ({ target }, showspinner) => {
    if (target) target.disabled = true;
    //console.log(showspinner);
    if (showspinner) this.setState({ loading: true });
    const { empresa } = this.state
    const { tipo, historial } = this.state
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial: this.state.numero_inicial,
      numero_final: this.state.numero_final,
      tipo_doc: this.state.tipo_documento,
      estado: (historial) ? "4" : "0,1,2,3,5,6"
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/documents/current', datasend)
      .then(res => res.json())
      .then((data) => {
        if (data.ok) {
          const datos = data.data;
          this.setState({ documentos: datos, loading: false });
          this.reconteo();
        } else {
          if (data.code === "0000") this.setState({ documentos: [], loading: false });
        }
        if (target) target.disabled = false;
        setTimeout(() => { this.updateInfo({ target }, false) }, 30000);
      })
      .catch((error) => console.error(error));
  }

  onePdf = ({ target }) => {
    target.disabled = true;
    if (this.state.listAllPDF >= 100) {
      this.setState({ visObsPDF: true });
    } else {
      this.setState({ loading: true });
    }
    const { empresa, historial } = this.state;
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial: this.state.numero_inicial,
      numero_final: this.state.numero_final,
      tipo_doc: this.state.tipo_documento
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': (historial) ? '3' : '1'
      }
    };
    fetch(config.servBackEnd + '/files/getonepdf', datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, "facturas.pdf");
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
        this.setState({ loading: false });
      })
  }

  buscar = ({ target }) => {
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  getPDF = ({ target }, doc) => {
    target.disabled = true;
    const { empresa } = this.state;

    const id = doc.ID_FACTURA;
    const tipo = doc.PREFIJO_DIAN;
    const numero = doc.NUMERO_FACTURA_CABECERA;
    const nombreArchivo = tipo + '-' + numero + '.pdf';

    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'blob',
        'empresa': empresa,
        'hist': '1'
      }
    }
    fetch(config.servBackEnd + '/files/getpdf/' + id, datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, nombreArchivo);
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
      })
  };

  getTirillaPDF = (e, doc) => {
    const { target } = e;
    target.disabled = true;
    const { empresa } = this.state;
    const id = doc.ID_FACTURA;
    const tipo = doc.PREFIJO_DIAN;
    const numero = doc.NUMERO_FACTURA_CABECERA;

    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
        'empresa': empresa
      }
    };
    fetch(config.servBackEnd + '/pos/factura-electronica-pdf/' + id, datasend)
      .then((res) => {
        if (res.ok) return res.blob();
        throw new Error(`Error ${res.status}: No se pudo generar la tirilla para el documento ${tipo}-${numero}`);
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          let objectURL = URL.createObjectURL(file);
          document.querySelector('#pdf-frame').src = '';
          document.querySelector('#pdf-frame').src = objectURL;
          objectURL = URL.revokeObjectURL(file);
          
          window.setTimeout(() => {
            document.querySelector('#pdf-frame').contentWindow.print();
            target.disabled = false;
          }, 1000);
        } else {
          target.disabled = false;
        }
      })
      .catch((err) => {
        console.error(err);
        toast({
          title: 'Error de Descarga',
          description: err.message || 'No se pudo descargar la tirilla PDF.',
          type: 'error',
          position: 'bottom-center',
          duration: 5
        });
        target.disabled = false;
      });
  };

  getXML = ({ target }, doc) => {
    target.disabled = true;
    const { empresa } = this.state;

    const id = doc.ID_FACTURA;
    const tipo = doc.PREFIJO_DIAN;
    const numero = doc.NUMERO_FACTURA_CABECERA;

    const tipoXml = target.name;
    let nombreArchivo = (tipoXml === "xml2") ? 'Response-' + tipo + '-' + numero + '.xml' : 'Attachement-' + tipo + '-' + numero + '.xml'
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'blob',
        'empresa': empresa,
        'estado': tipoXml,
        'hist': '1'
      }
    }
    fetch(config.servBackEnd + '/files/getxml/' + id, datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/text' });
          saveAs(file, nombreArchivo);
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
      })
      .catch((err) => {
        if (tipoXml === "xml1") {
          const newData = this.state.documentos;
          newData.forEach(element => {
            if (element.ID_FACTURA.toString() === id.toString()) {
              element.DOCUMENTO_ENVIADO_OBSERVACION = "Token vencido, intente nuevamente";
            }
          });
          this.setState({ documentos: newData })
        }
        target.disabled = false;
      })
  };

  enviarDoc = async ({ target }, doc) => {
    target.disabled = true;
    switch (this.state.provider) {
      case 'comfiar':
        await this.sendDocumentApi({
          typeProcess: target.name,
          url: `/documents/sendDocuments/${doc.ID_FACTURA}`
        })
        break;
      case 'teso':
        await this.sendDocumentApi({
          typeProcess: target.name,
          url: `/documents/v2/sendDocuments/${doc.ID_FACTURA}`
        })
        break;
      case 'radian':
        await this.sendDocumentApi({
          typeProcess: target.name,
          url: `/documents/v3/sendDocuments/${doc.ID_FACTURA}`
        })
        break;
      default:
        console.log("Invalid provider in company parameters")
        break;
    }

    target.disabled = false;
  };

  handleDeleteClick = (currentdata) => {
    this.setState({
      showConfirmModal: true,
      currentDeleteDoc: currentdata
    });
  };

  handleConfirmDelete = () => {
    const { empresa, currentDeleteDoc } = this.state;

    fetch(config.servBackEnd + '/documents/deleteinvoice/' + currentDeleteDoc.ID_FACTURA, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
      }
    })
      .then(res => res.json())
      .then((data) => {
        if (data.ok) {
          this.setState({ showSuccessModal: true });
          this.updateInfo({}, false);
        } else {
        toast({
          title: 'Error de Eliminación',
          description: "No se pudo eliminar la factura: " + data.message,
          type: 'error',
          position: 'bottom-center',
          duration: 5
        });
        }
      })
      .catch((error) => {
        console.error(error);
        toast({
          title: 'Error de Eliminación',
          description: "Error al eliminar la factura",
          type: 'error',
          position: 'bottom-center',
          duration: 5
        });
      });
  };

  limpiarFact = ({ target }, doc) => {
    target.disabled = true;
    const { empresa, tipo } = this.state;

    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;

    const datosUpdate = {
      newFechaDocumento: todayFormat,
      newFechaVencimiento: todayFormat,
      newDocumentoEnviado: "0",
      newObservacion: ""
    };

    const dataSend = {
      method: 'POST',
      body: JSON.stringify(datosUpdate),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };

    fetch(config.servBackEnd + '/documents/v2/clear/' + doc.ID_FACTURA, dataSend)
      .then(res => res.json())
      .then((data) => {
        target.disabled = false;
        if (data.ok) {
          let tmpDocuments = this.state.documentos;

          for (let index = 0; index < tmpDocuments.length; index++) {
            const elementDoc = tmpDocuments[index];

            if (elementDoc.ID_FACTURA.toString() === doc.ID_FACTURA.toString()) {
              elementDoc.FECHA_DOCUMENTO = datosUpdate.newFechaDocumento;
              elementDoc.FECHA_VENCIMIENTO_DOCUMENTO = datosUpdate.newFechaVencimiento;
              elementDoc.DOCUMENTO_ENVIADO = datosUpdate.newDocumentoEnviado;
              elementDoc.DOCUMENTO_ENVIADO_OBSERVACION = datosUpdate.newObservacion;
              break;
            }
          }

          this.setState({ documentos: tmpDocuments });
        } else {
          console.error('Error al actualizar el documento:', data.message);
        }

      })
      .catch((error) => console.error('Error en la solicitud:', error));
    target.disabled = false;
  };

  salidaDoc = async ({ target }, doc) => {
    target.disabled = true;
    switch (this.state.provider) {
      case 'comfiar':
        await this.sendDocumentApi({
          typeProcess: target.name,
          url: `/documents/salidaTran/${doc.ID_FACTURA}`
        })
        break;
      case 'radian':
        await this.sendDocumentApi({
          typeProcess: target.name,
          url: `/documents/v3/salidaTran/${doc.ID_FACTURA}`
        })
        break;
      default:
        console.log("Invalid provider in company parameters")
        break;
    }
    target.disabled = false;
  };

  mailerDoc = (e, doc) => {
    const { target } = e;
    target.disabled = true;
    const { empresa } = this.state;

    let docSend = []
    if (doc) {
      docSend = [{
        ID_FACTURA: doc.ID_FACTURA
      }]
    } else {
      docSend = this.state.docToSend.slice(0, 10);
      this.setState({ loading: true });
    }
    const datasend = {
      method: 'POST',
      body: JSON.stringify(docSend),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa
      }
    }
    if (docSend.length > 0) {
      fetch(config.servBackEnd + '/files/createsend', datasend)
        .then(res => res.json())
        .then((data) => {
          let tmpDocumentos = this.state.documentos;
          data.forEach(elementData => {
            for (let index = 0; index < tmpDocumentos.length; index++) {
              const elementDoc = tmpDocumentos[index];
              if (elementDoc.ID_FACTURA.toString() === elementData.ID_FACTURA.toString()) {
                elementDoc.DOCUMENTO_ENVIADO = elementData.estado;
                elementDoc.DOCUMENTO_ENVIADO_OBSERVACION = elementData.mensaje;
                break;
              }
            }
          });
          target.disabled = false;
          this.setState({ documentos: tmpDocumentos });
          this.reconteo();
          //if(!historial) this.updateInfo({});
        })
        .catch((error) => console.error(error))
    } else {
      //console.log("sin documentos pendientes por enviar");
      target.disabled = false;
      this.setState({ loading: false });
    }
  };

  reconteo = () => {
    const datos = this.state.documentos;
    let tmpDocPend = [];
    let tmpDocProc = [];
    let tmpDocSend = [];
    let allPdf = 0;
    datos.forEach(element => {
      if (element.DOCUMENTO_ENVIADO === "0") {
        tmpDocPend.push({
          ID_FACTURA: element.ID_FACTURA
        });
      }
      if (element.DOCUMENTO_ENVIADO === "1") {
        tmpDocProc.push({
          ID_FACTURA: element.ID_FACTURA
        });
      }
      if (element.DOCUMENTO_ENVIADO === "2") {
        tmpDocSend.push({
          ID_FACTURA: element.ID_FACTURA
        });
      }

      if (element.DOCUMENTO_ENVIADO === "2" || element.DOCUMENTO_ENVIADO === "4") {
        allPdf += 1;
      }
    });
    this.setState({ docPendientes: tmpDocPend, docProceso: tmpDocProc, docToSend: tmpDocSend, loading: false, listAllPDF: allPdf });
  };

  sendDocumentApi = async ({ typeProcess, url }) => {
    const { empresa, tipo, documentos } = this.state;
    const estado = (typeProcess === "reprocesar") ? 3 : 0;

    const datasend = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
        'estado': estado
      }
    }

    try {
      const response = await fetch(config.servBackEnd + url, datasend)
      const data = await response.json();
      const updatedDocumentos = documentos.map((docItem) => {
        if (docItem.ID_FACTURA.toString() === data.idFactura.toString()) {
          let updatedDocItem = { ...docItem };

          if (data.hasOwnProperty('estado'))
            updatedDocItem.DOCUMENTO_ENVIADO = data.estado;

          if (data.hasOwnProperty('idTransaccion'))
            updatedDocItem.ID_TRANSACCION = data.idTransaccion || '0';

          if (data.hasOwnProperty('mensaje'))
            updatedDocItem.DOCUMENTO_ENVIADO_OBSERVACION = data.mensaje;


          return updatedDocItem;
        } else {
          return docItem;
        }
      });
      this.setState({ documentos: updatedDocumentos });
    } catch (error) {
      console.log('sendDocumentApi', error)
    }
  }

  render() {
    //variables
    const facturas = this.state.documentos;
    const validacionUser = this.state.isLogin;
    const { searchTipo } = this.state;
    const { searchTipoDian } = this.state;
    const { searchNumero } = this.state;
    const { searchCliente } = this.state;
    const { searchTransaccion } = this.state;
    const { searchEstado } = this.state;
    const { loading } = this.state;
    const { resoluciones } = this.state;
    const { historial } = this.state;
    //const numbertosend = (this.state.docToSend.length > 10) ? 10 : this.state.docToSend.length;
    //funciones
    const enviarDoc = this.enviarDoc;
    const salidaDoc = this.salidaDoc;
    const mailerDoc = this.mailerDoc;
    const getPDF = this.getPDF;
    const getTirillaPDF = this.getTirillaPDF;
    const getXML = this.getXML;
    const handleDeleteClick = this.handleDeleteClick;
    const limpiarFact = this.limpiarFact;
    return (
      <div className="Menu">

        <Jumbotron className="Jumbotron">
          {!historial && <h2>Gestion de facturas</h2>}
          {historial && <h2>Historico de gestion</h2>}
        </Jumbotron>
        {!validacionUser && <p>La sesion se ha cerrado por favor ingrese de nuevo</p>}
        {validacionUser &&
          <div>
            <Container fluid>
              <Row className="justify-content-md-center" >
                <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>TIPO</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control as="select" onChange={e => this.setState({ tipo_documento: e.target.value })} value={this.state.tipo_documento} >
                    <option value=""></option>
                    {
                      resoluciones.map((resoluion, i) => {
                        return <option key={'td' + i} value={resoluion.PREFIJO}>{resoluion.PREFIJO}</option>;
                      })
                    }
                  </Form.Control>
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO INICIAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_inicial: e.target.value })} value={this.state.numero_inicial} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO FINAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_final: e.target.value })} value={this.state.numero_final} />
                </Col>
                {historial &&
                  <Col className="mb-2" xs={12} lg={2}>
                    <Button onClick={() => this.setState({ historial: false, documentos: [] })}  >Volver Gestion</Button>
                  </Col>
                }
                <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" name="actualizar" onClick={(e) => this.updateInfo(e, true)}  >Actualizar Documentos </Button>
                </Col>
                <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" disabled={facturas.length === 0} name="actualizar" onClick={this.onePdf}  >Generar PDF</Button>
                </Col>
                {!historial &&
                  <Col className="mb-2" xs={12} lg={2}>
                    <Button onClick={() => this.setState({ historial: true, documentos: [] })}   >Ver Historial</Button>
                  </Col>
                }
              </Row>
              {/* false &&
              <Row className="justify-content-md-center">
                <Col className="mb-2" xs={12} lg="2"><Button id="enviarTodo" name="enviarTodo" onClick={enviarDoc}  >Cargar DIAN todos
                  <Badge className="ml-1" variant="light">{this.state.docPendientes.length}</Badge>
                  <span className="sr-only">unread messages</span></Button>
                </Col>
                <Col className="mb-2" xs={12} lg="2">
                  <Button id="confirmarTodo" name="confirmarTodo" onClick={salidaDoc}  >Confirmar todos
                  <Badge className="ml-1" variant="light">{this.state.docProceso.length}</Badge>
                  </Button>
                </Col>
              </Row> */
              }
              <Row>
                <Col>
                  <Table hover bordered responsive size="sm">
                    <thead>
                      <tr>
                        <th></th>
                        <th><input type="text" maxLength="2" size="3" name="searchTipo" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="4" size="5" name="searchTipoDian" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="10" size="5" name="searchNumero" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="10" size="11" name="searchCliente" onChange={this.buscar} /></th>
                        <th><input type="text" maxLength="9" size="5" name="searchTransaccion" onChange={this.buscar} /></th>
                        {!historial && <th><select type="text" name="searchEstado" onChange={this.buscar} >
                          <option value="" defaultValue>Todos</option>
                          <option value="0">Sin Procesar</option>
                          <option value="1">pendiente DIAN</option>
                          <option value="2">Exitoso Dian</option>
                          <option value="3">Errores Dian</option>
                          <option value="5">Requiere Aprobacion</option>
                          <option value="6">Error Enviando Correo</option>
                          {historial && <option value="4">Correo Enviado</option>}
                        </select>
                        </th>}
                      </tr>
                      <tr>
                        <th>Fecha Documento</th>
                        <th>Tipo Documento</th>
                        <th>Prefijo Dian</th>
                        <th>Numero Documento</th>
                        <th>Nombre Cliente</th>
                        <th>No Transaccion</th>
                        <th>Estado</th>
                        <th>Observaciones</th>
                        <th colSpan="9">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(!loading && facturas.length > 0) &&
                        facturas.map(function (currentData, index) {
                          if (
                            ((!historial && currentData.DOCUMENTO_ENVIADO !== "4") || (historial))
                            && currentData.TIPO_DOCUMENTO_CABECERA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                            && currentData.PREFIJO_DIAN.toLowerCase().search(searchTipoDian.toLowerCase()) > -1
                            && currentData.NUMERO_FACTURA_CABECERA.toLowerCase().search(searchNumero.toLowerCase()) > -1
                            && currentData.NOMBRE_CLIENTE.toLowerCase().search(searchCliente.toLowerCase()) > -1
                            && currentData.ID_TRANSACCION.toLowerCase().search(searchTransaccion.toLowerCase()) > -1
                            &&
                            (currentData.DOCUMENTO_ENVIADO.toLowerCase().search(searchEstado.toLowerCase()) > -1
                              || searchEstado === ""
                            )
                          ) {
                            return <tr name={index} key={index + "d0"}>
                              <td name="tipo" >{funciones.formatDate(currentData.FECHA_DOCUMENTO)}</td>
                              <td name="tipo" >{currentData.TIPO_DOCUMENTO_CABECERA}</td>
                              <td name="dian" >{currentData.PREFIJO_DIAN}</td>
                              <td name="numero" >{currentData.NUMERO_FACTURA_CABECERA}</td>
                              <td name="cliente" >{currentData.NOMBRE_CLIENTE}</td>
                              <td name="transaccion" >{currentData.ID_TRANSACCION}</td>
                              <td name="estado" >{funciones.textEstado(currentData.DOCUMENTO_ENVIADO)}</td>
                              <td name="estadoObservacion" ><Modalobs text={funciones.textCut(currentData.DOCUMENTO_ENVIADO_OBSERVACION)} descripcion={currentData.DOCUMENTO_ENVIADO_OBSERVACION} />  </td>
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Cargar Documento</Tooltip>}>
                                <td ><Button className="buttonCa" onClick={(e) => enviarDoc(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "0")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>}
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Confirmar Estado</Tooltip>}>
                                <td ><Button className="buttonCo" onClick={(e) => salidaDoc(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "1")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>}
                              <OverlayTrigger placement='top' overlay={<Tooltip>Descargar Representacion Grafica</Tooltip>}>
                                <td ><Button className="buttonP" onClick={(e) => getPDF(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4" || currentData.DOCUMENTO_ENVIADO === "6")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>
                              <OverlayTrigger placement='top' overlay={<Tooltip>Descargar Representacion POS (Tirilla)</Tooltip>}>
                                <td ><Button className="buttonT" onClick={(e) => getTirillaPDF(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4" || currentData.DOCUMENTO_ENVIADO === "6")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Descargar XML Response</Tooltip>}>
                                <td ><Button className="buttonX1" onClick={(e) => getXML(e, currentData)} name="xml2" disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4" || currentData.DOCUMENTO_ENVIADO === "6")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>}
                              <OverlayTrigger placement='top' overlay={<Tooltip>Descargar XML Attachment</Tooltip>}>
                                <td ><Button className="buttonx2" onClick={(e) => getXML(e, currentData)} name="xml1" disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4" || currentData.DOCUMENTO_ENVIADO === "6")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>
                              <OverlayTrigger placement='top' overlay={<Tooltip>Enviar Correo al Cliente</Tooltip>}>
                                <td ><Button className="buttonE" onClick={(e) => mailerDoc(e, currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4" || currentData.DOCUMENTO_ENVIADO === "6")} variant="outline-primary"></Button></td>
                              </OverlayTrigger>
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Reprocesar</Tooltip>}>
                                <td ><Button className="buttonR" onClick={(e) => limpiarFact(e, currentData)} name="reprocesar" disabled={!((currentData.DOCUMENTO_ENVIADO === "1") || (currentData.DOCUMENTO_ENVIADO === "3"))} variant="outline-primary"></Button></td>
                              </OverlayTrigger>}
                              {!historial && <OverlayTrigger placement='top' overlay={<Tooltip>Eliminar</Tooltip>}>
                                <td><Button style={{ height: '35px', width: '35px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }} variant="outline-danger" onClick={() => handleDeleteClick(currentData)} disabled={!(currentData.DOCUMENTO_ENVIADO === "0")}><MdDeleteForever style={{ fontSize: '1.3rem' }} /></Button></td>
                              </OverlayTrigger>}
                            </tr>;
                          } else {
                            return null;
                          }
                        })}
                      {(!loading && facturas.length === 0) &&
                        <tr>
                          <td colSpan="8"> CONSULTA SIN RESULTADOS </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                  {(loading) && <Spinner loading={loading} />}
                </Col>
              </Row>
            </Container>
          </div>
        }
        <Modal
          show={this.state.visObsPDF}
          onHide={() => this.setState({ visObsPDF: false })}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              PDF EN PROCESO
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              EL PDF SE ESTA GENERANDO POR FAVOR NO RECARGAR LA PAGINA.
              <b>EL PDF SE DESCARGARA UNA VEZ ESTE LISTO</b>
            </p>
          </Modal.Body>
        </Modal>

        <CustomModal
          show={this.state.showConfirmModal}
          onHide={() => this.setState({ showConfirmModal: false })}
          title="Eliminar Factura"
          message="¿Está seguro de que desea eliminar esta factura? Esta acción no se puede deshacer."
          type="warning"
          confirmText="Eliminar"
          cancelText="Cancelar"
          onConfirm={this.handleConfirmDelete}
          showCancel={true}
          confirmVariant="danger"
        />

        <CustomModal
          show={this.state.showSuccessModal}
          onHide={() => this.setState({ showSuccessModal: false })}
          title="Factura Eliminada"
          message="La factura ha sido eliminada correctamente."
          type="success"
          confirmText="Aceptar"
          showCancel={false}
          confirmVariant="success"
        />

        <iframe id="pdf-frame" style={{ display: 'none' }} title="pdf-frame"></iframe>
      </div>
    );
  }
}
export default (Gestiones);


// WEBPACK FOOTER //
// ./src/components/factlectronica/gestiones.jsx